// extracted by mini-css-extract-plugin
export default {"errorBox":"CorruptedFileMessage_errorBox__HtP5X"};